import { __assign, __rest } from "tslib";
import { VariableSizeList as List } from 'react-window';
import React, { Children, memo, useCallback, useEffect, useMemo, useRef, } from 'react';
import { useWindowSizeHook } from '@mercell/use-window-resize-react-hook';
import { VirtualRowMenuList } from './VirtualRowMenuList';
var DefaultItemHeight = 50;
var DefaultItemSpacing = 8;
export function getFocusedIndex(children) {
    return Math.max(children.findIndex(function (child) { return child.props.isFocused; }), 0);
}
export var VirtualMenuList = memo(function (_a) {
    var menuListChildren = _a.children, innerRef = _a.innerRef, maxHeight = _a.maxHeight;
    var parsedChildrenToArray = useMemo(function () { return Children.toArray(menuListChildren); }, [menuListChildren]);
    var currentIndex = useMemo(function () { return getFocusedIndex(parsedChildrenToArray); }, [parsedChildrenToArray]);
    var sizeMap = useRef({});
    var itemCount = parsedChildrenToArray.length;
    var list = useRef(null);
    var width = useWindowSizeHook().width;
    var wrapperHeight = maxHeight < parsedChildrenToArray.length * DefaultItemHeight
        ? maxHeight
        : parsedChildrenToArray.length * DefaultItemHeight;
    var setSize = useCallback(function (index, size) {
        var _a;
        var _b;
        sizeMap.current = __assign(__assign({}, sizeMap.current), (_a = {}, _a[index] = size, _a));
        (_b = list === null || list === void 0 ? void 0 : list.current) === null || _b === void 0 ? void 0 : _b.resetAfterIndex(index);
    }, []);
    var getSize = useCallback(function (index) {
        if (!sizeMap.current[index] ||
            sizeMap.current[index] < DefaultItemHeight) {
            return DefaultItemHeight;
        }
        return sizeMap.current[index] + DefaultItemSpacing;
    }, []);
    useEffect(function () {
        if (currentIndex >= 0 && list.current !== null) {
            list.current.scrollToItem(currentIndex);
        }
    }, [currentIndex, parsedChildrenToArray, list]);
    return (React.createElement(List, { ref: list, outerRef: innerRef, estimatedItemSize: DefaultItemHeight, height: wrapperHeight, width: "100%", overscanCount: 10, itemCount: itemCount, itemData: parsedChildrenToArray, itemSize: getSize }, function (_a) {
        var data = _a.data, index = _a.index, style = _a.style;
        return (React.createElement("div", { style: style, key: "option-".concat(index) },
            React.createElement(VirtualRowMenuList, { data: data, setSize: setSize, index: index, windowWidth: width })));
    }));
}, function (prevProps, nextProps) {
    var prevChildren = prevProps.children, restPrevProps = __rest(prevProps, ["children"]);
    var nextChildren = nextProps.children, restNextProps = __rest(nextProps, ["children"]);
    try {
        return (JSON.stringify(restPrevProps) === JSON.stringify(restNextProps));
    }
    catch (e) {
        return false;
    }
});
